import assign from '../_helpers/assign.js';
import initMK from '../_core/init.js';
import reportModified from './_reportmodified.js';
import processRendering from './_processrendering/index.js';
// creates item mediator
function createItemMediator(_ref) {
  var arr = _ref.arr,
    mediator = _ref.mediator;
  return function itemMediator(value, index) {
    // args: value, index, array itself
    return mediator.call(arr, value, index, arr);
  };
}
// defines a "type" of every array item
export default function mediateItem(mediator) {
  var def = initMK(this);
  var length = this.length;
  var added = [];
  var removed = [];
  // store itemMediator in object definition
  var itemMediator = createItemMediator({
    arr: this,
    mediator: mediator
  });
  def.itemMediator = itemMediator;
  // convert existing items
  for (var i = 0; i < length; i++) {
    var item = this[i];
    var mediated = itemMediator(item, i);
    if (mediated !== item) {
      removed.push(item);
      added.push(mediated);
    }
    this[i] = mediated;
  }
  if (added.length) {
    var eventOptions = {
      method: 'recreate',
      self: this,
      added: added,
      removed: removed
    };
    var _this$renderIfPossibl = this.renderIfPossible,
      renderIfPossible = _this$renderIfPossibl === void 0 ? true : _this$renderIfPossibl;
    // no array events are fired, as before, but converted items are rendered as usual (with render hooks)
    reportModified(this, assign({}, eventOptions, {
      silent: true,
      dontRender: true
    }));
    if (renderIfPossible) {
      processRendering({
        self: this,
        eventOptions: eventOptions
      });
    }
  }
  return this;
}